import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ContestFilterService {
    private _listners = new Subject<any>();

    listen(): Observable<any> {
        return this._listners.asObservable();
    }

    filter(model: any) {
        this._listners.next(model);
    }
}



// WEBPACK FOOTER //
// ./src/services/contest.filter.service.ts